import React from 'react'
import {IconProps, IconWrapper} from './IconWrapper'

const renderIcon = (color: string) => {
    return (
        <>
            <g clipPath="url(#clip0_849_3020)">
                <path
                    d="M9.66663 13.7501L11.4999 11.9168M11.4999 11.9168L13.3333 10.0835M11.4999 11.9168L9.66663 10.0835M11.4999 11.9168L13.3333 13.7501M21.5833 13.7502C21.5833 11.7251 19.9417 10.0835 17.9166 10.0835C17.8949 10.0835 17.8738 10.0837 17.8522 10.0841C17.4076 6.97418 14.7328 4.5835 11.5 4.5835C8.93636 4.5835 6.7243 6.08687 5.69649 8.26008C3.30685 8.41649 1.41663 10.4042 1.41663 12.8334C1.41663 15.3647 3.46865 17.4169 5.99996 17.4169L17.9166 17.4168C19.9417 17.4168 21.5833 15.7752 21.5833 13.7502Z"
                    stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
            <defs>
                <clipPath id="clip0_849_3020">
                    <rect width="22" height="22" fill={color} transform="translate(0.5)"/>
                </clipPath>
            </defs>
        </>
    )
}

export const CloudFail: React.FC<IconProps> = ({color, size}) => (
    <IconWrapper viewBox={'0 0 22 22'} {...{size, color, renderIcon}} />
)
